import React from "react";
import { withRouter } from "../utilities/withRouter";
import { Button, ActionIcon } from "@mantine/core";

import "./ButtonWithIcon.css";

const SmallNoPaddingIconButton = ({ children, ...rest }) => (
	<ActionIcon variant="subtle" size="sm" p={0} {...rest}>
		{children}
	</ActionIcon>
);

const getButtonProps = (className) => {
	if (className === "blue") return { variant: "filled", color: "lxw-blue" };
	if (className === "redButton")
		return { variant: "filled", color: "lw-red" };
	if (className === "goldButton")
		return { variant: "filled", color: "lw-gold" };
	return { variant: "default" };
};

class ButtonWithIconBase extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			fileUploadTarget: null,
		};
		this.handleClick = this.handleClick.bind(this);
		this.handleFileListChange = this.handleFileListChange.bind(this);
	}
	handleClick(e) {
		if (this.props.disabled) return;
		if (
			this.props.type === "multi-upload" ||
			this.props.type === "single-upload"
		) {
			this.setState({
				fileUploadTarget: e.target,
			});
		}
		if (this.props.type === "go-back") {
			window.safeGoBack(this.props.defaultGoBackLocation);
		} else {
			this.props.redirect && this.redirect(this.props.redirect);
			this.props.handler && this.props.handler();
		}
	}
	redirect(eventKey) {
		// history comes from routers withRouter method
		const { history } = this.props;
		history.push(eventKey);
	}

	handleFileListChange(event) {
		var files = event.target.files;
		if (this.props.fileListChangeHandler && files.length) {
			this.props.fileListChangeHandler(files, () => {
				console.log("setting null filelistchange");
				this.setState({
					fileUploadTarget: { value: null },
				});
			});
		}
	}
	render() {
		const buttonProps = getButtonProps(this.props.className);
		return (
			<span
				title={
					this.props.disabled
						? this.props.disabledHoverText
						: this.props.title
				}
				style={{ minWidth: "fit-content" }}
			>
				<Button
					{...buttonProps}
					component="label"
					disabled={this.props.disabled}
					onClick={this.handleClick}
					className={this.props.className || ""}
					style={this.props.style || undefined}
				>
					<div
						className="ButtonInner"
						style={
							this.props.buttonText
								? undefined
								: {
										display: "flex",
										alignItems: "center",
									}
						}
					>
						{this.props.iconComponent
							? this.props.iconComponent
							: null}
						{this.props.buttonText ? (
							<span
								className="ButtonText"
								style={{
									marginLeft: this.props.iconComponent
										? 8
										: 0,
								}}
							>
								{this.props.buttonText}
							</span>
						) : null}
					</div>
					{this.props.type === "multi-upload" ? (
						<input
							disabled={this.props.disabled || null}
							type="file"
							style={{ display: "none" }}
							multiple="multiple"
							onChange={this.handleFileListChange}
							accept={this.props.uploadAccept || "*"}
							onClick={(event) => {
								event.target.value = null;
							}}
						/>
					) : this.props.type === "single-upload" ? (
						<input
							disabled={this.props.disabled || null}
							type="file"
							style={{ display: "none" }}
							onChange={this.handleFileListChange}
							accept={this.props.uploadAccept || "*"}
							onClick={(event) => {
								event.target.value = null;
							}}
						/>
					) : null}
				</Button>
			</span>
		);
	}
}
const ButtonWithIcon = ButtonWithIconBase;
const ButtonWithRouter = withRouter(ButtonWithIcon);
export { ButtonWithIcon, ButtonWithRouter, SmallNoPaddingIconButton };
